import React from "react";
import { CLIENT_COMPANY_INFO } from "../../constants/updateClientContants";
import UpdateClientProfilesWrapper from "../../container/UpdateClientProfilesWrapper/UpdateClientProfilesWrapper";

const UpdateClientCompanyInfo = () => (
  <UpdateClientProfilesWrapper bodyContent={CLIENT_COMPANY_INFO} />
);

export default UpdateClientCompanyInfo;
